import { ReachIntegration } from '@reach/interfaces/integrations/integration-type.enum';

export enum ReachImport {
	MARKDOWN = 'MARKDOWN',
	WORD_DOCX = 'WORD_DOCX',
	WEBSITE_SUBPAGES = 'WEBSITE_SUBPAGES',
}

export type ReachIntegrationOrImport = ReachIntegration | ReachImport;
